module.exports = {
  "zones": {
    "Pacific/Kwajalein": ["z", {
      "wallclock": 745891200000,
      "format": "+12",
      "abbrev": "+12",
      "offset": 43200000,
      "posix": 745934400000,
      "save": 0
    }, {
      "wallclock": -7948800000,
      "format": "-12",
      "abbrev": "-12",
      "offset": -43200000,
      "posix": -7988400000,
      "save": 0
    }, {
      "wallclock": -817430400000,
      "format": "+11",
      "abbrev": "+11",
      "offset": 39600000,
      "posix": -817462800000,
      "save": 0
    }, {
      "wallclock": -907372800000,
      "format": "+09",
      "abbrev": "+09",
      "offset": 32400000,
      "posix": -907408800000,
      "save": 0
    }, {
      "wallclock": -1041379200000,
      "format": "+10",
      "abbrev": "+10",
      "offset": 36000000,
      "posix": -1041418800000,
      "save": 0
    }, {
      "wallclock": -2177452800000,
      "format": "+11",
      "abbrev": "+11",
      "offset": 39600000,
      "posix": -2177492960000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 40160000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};